module.exports = __webpack_public_path__ + "static/img/wd196b1dfb.png";